export const pathAPI = {
  doSubmitAccess: "/v1/login_wifi/submit_access",
  loadConfigAd: "/v1/ad_management/config_ad",
  trackActivity: "/v1/ad_management/track_activity",
  trackActivityBatch: "/v1/network_management/track_activity_batch", // New batch endpoint
  recordAccess: "/v1/login_wifi/record_login",
  generateOTP: "/v1/login_wifi/generate_otp",
  submitOTP: "/v1/login_wifi/submit_otp",
  submitSurvey: "/v1/network_management/add_survey",
  verifyPhoneNumber: "/v1/login_wifi/verify_phonenumber",
  verifyMacAddress: "/v1/login_wifi/verify_mac_address",
};

export const pathLoginPortal = {
  tplink: "portal/radius/auth",
};
